import React from 'react';
import useRoomState from '../../hooks/useRoomState/useRoomState';
import LocalVideoPreview from '../LocalVideoPreview/LocalVideoPreview';
import Room from '../Room/Room';

// Only the remote (client) feed — the therapist self-preview stays in the Main area
// and is rendered separately so it does not move with the view-swap.
const PractitionerCameraPreview = () => {
  const roomState = useRoomState();

  return (
    <div
      style={{
        position: 'relative',
        width: '100%',
        height: '100%',
        overflow: 'hidden',
        borderRadius: 'inherit',
      }}
    >
      {roomState === 'disconnected' ? <LocalVideoPreview /> : <Room />}
    </div>
  );
};

export default PractitionerCameraPreview;
